import { useTranslation } from "react-i18next";
import { faArrowUpRight } from "@fortawesome/pro-light-svg-icons";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { VaporIcon } from "@vapor/react-icons";
import { Box, Stack, useTheme } from "@vapor/react-material";
import { useNavigate } from "react-router-dom";
import type { TaxSubmissionDetailDTO } from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import {
    createNavigationUrl,
    processUrn,
} from "../../../../../utils/resolveUrn";
import type { SecondaryOption } from "../TaxSubmissionDetailToolbar";

export const useGetCtaGoToProcedure = (
    taxSubmissionDetail: TaxSubmissionDetailDTO,
): SecondaryOption => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const theme = useTheme();

    return {
        element: (
            <Stack
                direction="row"
                onClick={() => {
                    if (taxSubmissionDetail.ownerApp.taxSubmissionPath) {
                        navigate(
                            createNavigationUrl(
                                taxSubmissionDetail.ownerApp.taxSubmissionPath,
                            ),
                        );
                    } else {
                        navigate(
                            createNavigationUrl(
                                processUrn(taxSubmissionDetail.ownerApp.urn),
                            ),
                        );
                    }
                }}
            >
                <VaporIcon icon={faArrowUpRight} color="interactive" />
                <Box sx={{ mr: 1 }} />
                <Typography color={theme.palette.primary.interactiveDefault}>
                    {t(
                        "views.home.components.tax_submission_detail_toolbar.secondary_cta.go_to_procedure",
                    )}
                </Typography>
            </Stack>
        ),
    };
};
